/**
 * Whether QA-only gameplay rules are in effect.
 *
 * Several systems relax shipping behaviour for the scripted navigator
 * (no jump-cut / fast-fall, no fall damage, no checkpoint reload, no
 * solo-follow, …). These used to key off the mere presence of
 * `window.__qa`, which every DEV build installs, so anyone playtesting on
 * `npm run dev` played a different game from players. They are now
 * opt-in: a QA tool must load the page with `?qaRules=1` (DEV builds
 * only). `window.__qa` stays available for read-only inspection either way.
 */
export function qaRulesActive(): boolean {
  if (!import.meta.env.DEV || typeof window === "undefined") return false;
  const w = window as { __qaRules?: boolean };
  if (w.__qaRules === undefined) {
    try {
      w.__qaRules = new URLSearchParams(window.location.search).get("qaRules") === "1";
    } catch {
      w.__qaRules = false;
    }
  }
  return w.__qaRules === true;
}
